import { cmsInstance } from "../axios/axiosInstance";

export const getProductFaqs = async ({ queryKey }: any) => {
  const payload = queryKey[1];
  const data = await cmsInstance.post(`/Faq/GetProductFaqs`, payload);
  return data.data;
};
